export default "__VITE_ASSET__CnohxQYB__ 288w, __VITE_ASSET__6MGMLU6n__ 432w, __VITE_ASSET__D3KpOV4Z__ 576w";